"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var errorMessages = {
  generic: 'Something went wrong. Please try again.',
  internetConnection: 'Please check your internet connection and try again later.',
  emptyField: 'Please fill in this field.',
  invalidEmail: 'Please enter a valid email address.',
  configurationExists: 'The configuration for this community already exists.'
};
var _default = errorMessages;
exports.default = _default;